export default __webpack_public_path__ + "static/media/LO13.1.2db72926.mp3";